const _temp0 = require("../FDebug.vue");
const _temp1 = require("../FDropDownBox.vue");
const _temp2 = require("../FDropDownHeader.vue");
const _temp3 = require("../FInput.vue");
const _temp4 = require("../FList.vue");
const _temp5 = require("../FSexyScroll.vue");
const _temp6 = require("../action/FButton.vue");
const _temp7 = require("../action/FButtonButton.vue");
const _temp8 = require("../action/FButtonLink.vue");
const _temp9 = require("../action/FSwitchButtonsGroup.vue");
const _temp10 = require("../action/FSwitchButtonsGroupButton.vue");
const _temp11 = require("../action/FWrapper.vue");

const _temp12 = require("../control/FDoubleSlider.vue");
const _temp13 = require("../control/FProgressBar.vue");
const _temp14 = require("../control/FSlider.vue");
const _temp15 = require("../control/FSliderHeavy.vue");

const _temp16 = require("../feedback/FDialog.vue");
const _temp17 = require("../feedback/FItemProgressing.vue");
const _temp18 = require("../feedback/FItemsProgressing.vue");
const _temp19 = require("../feedback/FModalBase.vue");
const _temp20 = require("../feedback/FSimpleTooltip.vue");
const _temp21 = require("../feedback/FToast.vue");
const _temp22 = require("../feedback/FToastBase.vue");
const _temp23 = require("../feedback/FTooltip.vue");

const _temp24 = require("../display/FBulletNumber.vue");

const _temp25 = require("../form/FField.vue");
const _temp26 = require("../form/FForm.vue");

const _temp27 = require("../icon/FIcon.vue");

const _temp28 = require("../information/FDescription.vue");
const _temp29 = require("../information/FHint.vue");
const _temp30 = require("../information/FHintBase.vue");
const _temp31 = require("../information/FInfo.vue");
const _temp32 = require("../information/FStatus.vue");
const _temp33 = require("../information/FThumb.vue");
const _temp34 = require("../information/FValue.vue");
const _temp35 = require("../information/date/DateFromTimestamp.vue");
const _temp36 = require("../information/date/LongDate.vue");
const _temp37 = require("../information/date/MediumDate.vue");
const _temp38 = require("../information/date/ShortDate.vue");


const _temp39 = require("../input/FCheckbox.vue");
const _temp40 = require("../input/FDate.vue");
const _temp41 = require("../input/FDateTimeLocal.vue");
const _temp42 = require("../input/FMultiUpload.vue");
const _temp43 = require("../input/FPassword.vue");
const _temp44 = require("../input/FRadioButton.vue");
const _temp45 = require("../input/FRadioButtonCard.vue");
const _temp46 = require("../input/FRadioButtonCards.vue");
const _temp47 = require("../input/FSelect.vue");
const _temp48 = require("../input/FTextarea.vue");
const _temp49 = require("../input/FTextfield.vue");
const _temp50 = require("../input/FTime.vue");
const _temp51 = require("../input/FToggle.vue");
const _temp52 = require("../input/FUpload.vue");

const _temp53 = require("../loading/FLoaderCircular.vue");

const _temp54 = require("../navigation/FDropDownButton.vue");
const _temp55 = require("../navigation/FLink.vue");
const _temp56 = require("../navigation/FListItem.vue");
const _temp57 = require("../navigation/FMiniTab.vue");
const _temp58 = require("../navigation/FMiniTabs.vue");
const _temp59 = require("../navigation/FProjectTab.vue");
const _temp60 = require("../navigation/FProjectTabs.vue");
const _temp61 = require("../navigation/FTag.vue");

const _temp62 = require("../transition/FFadeListTransition.vue");
const _temp63 = require("../transition/FFadeScaleTransition.vue");
const _temp64 = require("../transition/FFadeTransition.vue");
const _temp65 = require("../transition/FFadeTransitionOutIn.vue");

module.exports = {
  "FDebug": _temp0,
  "FDropDownBox": _temp1,
  "FDropDownHeader": _temp2,
  "FInput": _temp3,
  "FList": _temp4,
  "FSexyScroll": _temp5,
  "action":   {
    "FButton": _temp6,
    "FButtonButton": _temp7,
    "FButtonLink": _temp8,
    "FSwitchButtonsGroup": _temp9,
    "FSwitchButtonsGroupButton": _temp10,
    "FWrapper": _temp11
  },
  "control":   {
    "FDoubleSlider": _temp12,
    "FProgressBar": _temp13,
    "FSlider": _temp14,
    "FSliderHeavy": _temp15
  },
  "feedback":   {
    "FDialog": _temp16,
    "FItemProgressing": _temp17,
    "FItemsProgressing": _temp18,
    "FModalBase": _temp19,
    "FSimpleTooltip": _temp20,
    "FToast": _temp21,
    "FToastBase": _temp22,
    "FTooltip": _temp23
  },
  "display":   {
    "FBulletNumber": _temp24
  },
  "form":   {
    "FField": _temp25,
    "FForm": _temp26
  },
  "icon":   {
    "FIcon": _temp27
  },
  "information":   {
    "FDescription": _temp28,
    "FHint": _temp29,
    "FHintBase": _temp30,
    "FInfo": _temp31,
    "FStatus": _temp32,
    "FThumb": _temp33,
    "FValue": _temp34,
    "date":     {
      "DateFromTimestamp": _temp35,
      "LongDate": _temp36,
      "MediumDate": _temp37,
      "ShortDate": _temp38
    }
  },
  "input":   {
    "FCheckbox": _temp39,
    "FDate": _temp40,
    "FDateTimeLocal": _temp41,
    "FMultiUpload": _temp42,
    "FPassword": _temp43,
    "FRadioButton": _temp44,
    "FRadioButtonCard": _temp45,
    "FRadioButtonCards": _temp46,
    "FSelect": _temp47,
    "FTextarea": _temp48,
    "FTextfield": _temp49,
    "FTime": _temp50,
    "FToggle": _temp51,
    "FUpload": _temp52
  },
  "loading":   {
    "FLoaderCircular": _temp53
  },
  "navigation":   {
    "FDropDownButton": _temp54,
    "FLink": _temp55,
    "FListItem": _temp56,
    "FMiniTab": _temp57,
    "FMiniTabs": _temp58,
    "FProjectTab": _temp59,
    "FProjectTabs": _temp60,
    "FTag": _temp61
  },
  "transition":   {
    "FFadeListTransition": _temp62,
    "FFadeScaleTransition": _temp63,
    "FFadeTransition": _temp64,
    "FFadeTransitionOutIn": _temp65
  }
}